import { render, staticRenderFns } from "./option.vue?vue&type=template&id=a23ebba2&scoped=true&"
import script from "./option.vue?vue&type=script&lang=js&"
export * from "./option.vue?vue&type=script&lang=js&"
import style0 from "./option.vue?vue&type=style&index=0&id=a23ebba2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23ebba2",
  null
  
)

export default component.exports